import React from "react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  className?: string;
  label?: string;
  fallbackPath?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  className = "",
  label = "Back",
  fallbackPath = "/dashboard",
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // console.log(window.history.length);
    // navigate(-1);
    // setTimeout(() => {
    //   if (window.history.length === 1) {
    navigate(fallbackPath);
    //   }
    // }, 0);
  };

  return (
    <button
      onClick={handleBack}
      className={`back-button ${className}`}
      aria-label="Go back"
      style={{
        width: "auto",
        padding: "8px 16px",
        fontSize: "14px",
      }}
    >
      {label}
    </button>
  );
};

export default BackButton;
